import { render, staticRenderFns } from "./WorkflowCard.vue?vue&type=template&id=5f67117c&"
import script from "./WorkflowCard.vue?vue&type=script&lang=ts&"
export * from "./WorkflowCard.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowCard.vue?vue&type=style&index=0&id=5f67117c&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports